import {
  combinedStatusOptions,
  onlyErirOptions
} from "constants/selectOptions/CombinedStatusOptions";
import FilterLayout from "Layout/FilterLayout";
import { FormEvent, useState } from "react";
import { Control, FieldValues, useForm } from "react-hook-form";
import { TInvoiceFilter } from "types/TInvoiceFilter";
import { DatePickerField, InputField, selectColorSchemes, SelectField } from "ui";
import useOrdAccountsList from "utils/useOrdAccountsList";

type Props = {
  filter: TInvoiceFilter;
  clearFilter: TInvoiceFilter;
  onFilterClick: (_: TInvoiceFilter) => void;
  onClose: () => void;
};

export const InvoiceFilter = ({ filter, clearFilter, onFilterClick, onClose }: Props) => {
  const [statusTitlesOptions, setStatusTitlesOptions] = useState(
    filter.ord_account?.length ? onlyErirOptions : combinedStatusOptions
  );

  const { control, watch, reset, setValue } = useForm({
    defaultValues: filter
  });

  const {
    options: ordAccountsTitlesOptions,
    isLoading: ordAccountsLoading,
    isError: ordAccountsError
  } = useOrdAccountsList();

  const onSubmit = (e: FormEvent) => {
    e.preventDefault();
    onFilterClick(watch());
  };

  const onReset = () => {
    reset(clearFilter);
    onFilterClick(clearFilter);
  };

  return (
    <FilterLayout onSubmit={onSubmit} onReset={onReset} onClose={onClose}>
      <SelectField
        name="ord_account"
        control={control as unknown as Control<FieldValues, any>}
        title="Аккаунт в ОРД"
        isMulti
        options={ordAccountsTitlesOptions}
        disabled={ordAccountsLoading || ordAccountsError}
        onChange={(newVal) => {
          if (newVal && (newVal as (string | number)[]).length) {
            setValue(
              "combined_status",
              watch("combined_status")?.filter((st) => st === 4 || st === 5 || st === 6)
            );
            setStatusTitlesOptions(onlyErirOptions);
          } else {
            setStatusTitlesOptions(combinedStatusOptions);
          }
        }}
      />
      <SelectField
        name="combined_status"
        control={control as unknown as Control<FieldValues, any>}
        title="Статус"
        isMulti
        options={statusTitlesOptions}
        colorSchemes={{
          4: selectColorSchemes.yellow,
          5: selectColorSchemes.green,
          6: selectColorSchemes.red
        }}
      />
      <DatePickerField
        name="start_date"
        control={control as unknown as Control<FieldValues, any>}
        title="Начало периода"
        returnFormat="yyyy-MM-dd"
      />
      <DatePickerField
        name="end_date"
        control={control as unknown as Control<FieldValues, any>}
        title="Конец периода"
        returnFormat="yyyy-MM-dd"
      />
      <InputField
        name="invoice_number"
        control={control as unknown as Control<FieldValues, any>}
        title="Номер акта"
      />
    </FilterLayout>
  );
};
